module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1005-43d782028273e5107ca3f8965962c2f1.png";